
import { mapState } from 'vuex';
import AppAiIcon from '@/components/core/AppAiIcon';
import AiIconType from '@/enums/AiIconType';

export default {
  i18nComponentKey: 'WidgetAddOnSizeRecommendationPopup.components.SizeRecommendationBadge',
  name: 'SizeRecommendationBadge',
  components: { AppAiIcon },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    isGradientAiIconType() {
      return this.reviewSettings.ai_icon_type === AiIconType.GRADIENT;
    }
  }
};
